const numbers = '0123456789';

export default (str: string) =>
  [...(str || '')].filter((c) => numbers.indexOf(c) !== -1).join('');
